module.exports = __webpack_public_path__ + "img/bust.0e2db6c9.png";